import { Outlet, useLocation } from 'react-router'
import { ErrorBoundary } from '../platform/async/ErrorBoundary'
import './shell.css'

/**
 * Pre-login. No nav, no breadcrumb — there is nothing to navigate to before
 * there is a session, and a sidebar full of links that all bounce to sign-in is
 * a worse experience than none.
 */
export function BareLayout() {
  // Keyed to the pathname for the same reason ChromeLayout's <main> is: `.enter`
  // is a CSS animation and a CSS animation fires on mount, so without this the
  // 6px rise plays once across the whole pre-login flow — sign-in to sign-up to
  // reset-password would all be one uninterrupted mount.
  const { pathname } = useLocation()
  return (
    <main
      key={pathname}
      // `tabIndex={-1}` even though there is no skip link here — #194.
      //
      // It makes this a focus TARGET without adding a tab stop, and the toast
      // queue's focus chain ends at `main[tabindex]`: with no neighbour and a
      // trigger that has unmounted itself, a keyboard user otherwise lands on
      // `<body>`. web-architect measured that against this file's exact markup.
      //
      // It matters here specifically because `main.tsx` mounts `ToastProvider`
      // inside `AuthProvider` so an auth screen can report an outcome — and the
      // auth screens are the ones this layout renders. Excluding an unfocusable
      // `<main>` from that selector is right (focusing it is a no-op that reads
      // as a successful restore); giving this one the attribute is the other
      // half of that decision rather than a looser selector.
      tabIndex={-1}
      className="enter bare"
    >
      {/* #95, and it matters more here than in the chrome: a pre-login surface
          has no navigation to fall back on, so a blank page is a dead end. */}
      <ErrorBoundary name="This page">
        <Outlet />
      </ErrorBoundary>
    </main>
  )
}
